import { useMemo } from "react";
import { calculateElapsedTimes } from "../../lib/templateItemElapsedTime";

export interface TemplateItemRow {
  readonly key: string;
  readonly category: string;
  readonly timeEstimate: string | null;
  readonly itemName: string;
  readonly question: string | null;
  readonly note: string | null;
  readonly isRequired: boolean;
}

export function TemplateItemsViewTable({
  items,
}: {
  items: TemplateItemRow[];
}) {
  const elapsedTimes = useMemo(() => calculateElapsedTimes(items), [items]);

  return (
    <div>
      <div className="mb-4 text-[var(--color-text-secondary)] text-sm">
        項目数: {items.length}件
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-[var(--color-bg-subtle-gray)]">
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                カテゴリ
              </th>
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                時間目安
              </th>
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                経過時間
              </th>
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                項目
              </th>
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                質問/発話
              </th>
              <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                補足
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={item.key}
                className="border-[var(--color-border-default)] border-b"
              >
                <td className="p-3 font-medium text-sm">{item.category}</td>
                <td className="p-3 text-[var(--color-text-secondary)] text-sm">
                  {item.timeEstimate || "-"}
                </td>
                <td className="p-3 text-[var(--color-text-secondary)] text-sm">
                  {elapsedTimes[index] > 0 ? `${elapsedTimes[index]}分` : "-"}
                </td>
                <td className="p-3 text-sm">
                  {item.isRequired && (
                    <span className="text-[var(--color-text-danger)]">⭐ </span>
                  )}
                  {item.itemName}
                </td>
                <td className="max-w-[300px] whitespace-pre-wrap break-words p-3 text-[var(--color-text-secondary)] text-sm">
                  {item.question || "-"}
                </td>
                <td className="max-w-[300px] whitespace-pre-wrap break-words p-3 text-[var(--color-text-tertiary)] text-sm">
                  {item.note || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
